
    var riot = require('riot')
    //src: starling/src/tags/raw.html
riot.tag2('raw',
  '',
  '',
  '', function(opts) {
'use strict';

var _this = this;

var set = function set() {
  _this.root.innerHTML = opts && opts.html;
};
this.on('mount', set);
this.on('update', set);
this.parent.on('update', set);
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('raw')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/raw.html
// module id = 589
// module chunks = 0